import React from "react"
import Layout from "../components/layout"
import Img from "gatsby-image"
import SEO from "../components/seo"
import Container from "../components/container"
import styled from "@emotion/styled"
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

import {
  Twitter, 
  Facebook, 
  Mail, 
  Reddit, 
} from 'react-social-sharing'

import {
  Box, 
  Heading, 
  Grid, 
  Text, 
  Button, 
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useDisclosure, 
} from "@chakra-ui/core";

import theme from "../theme";

const Styles = styled.div`
    // box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    // grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));

    min-height: 60vh;


    .my-box {
      a {
        margin: 0px;
      }
  
      .my-link {
        margin: 0px;
        font-size: 14px;
        border-radius: 2px;
        padding: 2px 6px;
        margin-right: 4px;
        margin-bottom: 4px;
      }
    }
`

export default class extends React.Component {
  constructor ( props ) {
    super();
    this.state = {};
    this.state.node = props.pageContext.node; 
  } 

  componentDidMount () {
    var disqus_config = function () {
      this.page.url = this.state.node.slug;  // Replace PAGE_URL with your page's canonical URL variable
      this.page.identifier = this.state.node.id; // Replace PAGE_IDENTIFIER with your page's unique identifier variable
      };
      (function() { // DON'T EDIT BELOW THIS LINE
      var d = document, s = d.createElement('script');
      s.src = 'https://prolific-coast-seeds.disqus.com/embed.js';
      s.setAttribute('data-timestamp', +new Date());
      (d.head || d.body).appendChild(s);
      })();
  }

  blogImage (el) {
    // check for image
    return (
      <Box data-id={el.id} minHeight="200px" height="16vw" overflow="hidden" cursor="pointer" onClick={ this.magnify.bind(this)} maxHeight="220px">
        <Img fluid={ el.fluid } style={{minHeight: "200px", height: "16vw", maxHeight: "220px"  }} imgStyle={{objectFit: "contain"}}/>
      </Box>
    )
  }

  magnify (e) {

    let image = this.state.node.resources.filter( (el) => {
      return el.id == e.currentTarget.dataset.id 
    })


    this.setState({
      activeImage: image[0].fluid
    })
    document.querySelectorAll(".image-modal")[0].click();
  }

  extraImages () {
    if ( this.state.node.resources[1]) {
      return <Box bg="gray.100" borderTopWidth="1px" borderColor="gray.900">
      <Container>
        <Grid templateColumns="repeat(auto-fill, minmax(175px, 1fr))" gap={4}>
          {
            this.state.node.resources.slice(1).map( this.blogImage.bind(this) )
          }

        </Grid>
      </Container>
    </Box>
    }
  }

  render() {
  

    return (
      <Layout >
        <SEO title={ this.state.node.title } />
        <ImageModal parent={ this } />
        <Styles>

        <Box bg="gray.100" color="gray.900">
            <Container>

              <Heading  textAlign={["center"]} mb={4} textTransform="uppercase">{ this.state.node.title }</Heading>

                <Box mb={2}>
                  <Box rounded="md" overflow="hidden" mb={2} cursor="pointer" maxWidth="200px" margin="0 auto" data-id={this.state.node.resources[0].id } onClick={ this.magnify.bind(this)}>
                  <Img fluid={ this.state.node.resources[0].fluid } />
                  </Box>
                </Box>

                <Box >

                  <Box textAlign="center" mb={2} >

                  <Box className="my-box" display="inline-block" >
                    <Mail size="medium" link={"https://prolificcoastseends.com/" + this.state.node.slug } className="my-link" />
                  </Box>


                  <Box className="my-box" display="inline-block" >
                   <Facebook size="medium" link={"https://prolificcoastseends.com/" + this.state.node.slug } className="my-link" />
                  </Box>

                  <Box className="my-box" display="inline-block" >
                    <Twitter size="medium" link={"https://prolificcoastseends.com/" + this.state.node.slug } className="my-link" />
                  </Box>

                  <Box className="my-box" display="inline-block" >
                  <Reddit size="medium" link={"https://prolificcoastseends.com/" + this.state.node.slug } className="my-link" />
                  </Box>

                  </Box>

                <Box textAlign="center">

                  <Text dangerouslySetInnerHTML={{__html: documentToHtmlString(this.state.node.description.json )}} maxWidth="600px" margin="0 auto" mb={4} >
                  </Text>


                  <Heading size="md" mb={2} mb={4}>
                    ${ this.state.node.price.toFixed(2) }
                  </Heading>

                  <Button
                    color={theme.white}
                    bg={theme.teal}
                    rounded="full"
                    _hover={{ bg: theme.blue }}
                    _active={{ bg: theme.yellow, color: "purple.500" }}
                    className="snipcart-add-item"
                    data-item-id={ this.state.node.id }
                    data-item-price={ this.state.node.price }
                    data-item-url={ "/store" +  this.state.node.slug }
                    data-item-description={ this.state.node.body.body }
                    data-item-image={ "https:" + this.state.node.resources[0].fluid.src }
                    data-item-name={ this.state.node.title }
                    mb={6}
                    >
                    Add To Cart
                      </Button>

                      </Box>
                  
                </Box>
              </Container>

              {
                this.extraImages()
              }

              


              <Box bg={"gray.200"} color="gray.900" borderTopWidth="1px" borderColor="gray.900" >
              <Container>
                <div id="disqus_thread"></div>
              </Container>
              </Box>

        </Box>

        </Styles>
      </Layout>
    )
  }
}

// export const query = graphql`
//   {
//     search: allContentfulCatalog {
//       nodes {
//         id
//         body {
//           body
//         }
//         title
//         price
//         slug
//         phenotypeInfo
//         finishTime  
//       }
//     }
//   }
// `


function ImageModal ( props ) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button onClick={onOpen} className="image-modal" opacity="0" height="0px" position="absolute"></Button>

      <Modal isOpen={isOpen} onClose={onClose} >
        <ModalOverlay />
        <ModalContent  rounded="md" overflow="hidden"  minWidth={"50vw"} minHeight={"50vh"}>
          <ModalBody   padding={[4, 6]} rounded="sm" overflow="hidden" >
            <Img fluid={ props.parent.state.activeImage } style={{minHeight: "45vh"}} imgStyle={{objectFit: "contain"}} />
          </ModalBody>

        </ModalContent>
      </Modal>
    </>
  );
}